<template>
  <AppChecklist v-if="surveyStore.mode === 'checklist'" />
  <AppSurvey v-else />
</template>

<script setup>
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';
import AppSurvey from './AppSurvey.vue';
import AppChecklist from './AppChecklist.vue';

const surveyStore = useSurveyStore();

surveyStore.decodeUrlParams();
</script>
